import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["id"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import u, { createContext as m, useContext as D, useMemo as l, useState as T } from "react";
import { useId as P } from '../../hooks/use-id.js';
import { forwardRefWithAs as g, render as E } from '../../utils/render.js';
import { useIsoMorphicEffect as x } from '../../hooks/use-iso-morphic-effect.js';
import { useSyncRefs as R } from '../../hooks/use-sync-refs.js';
import { useEvent as I } from '../../hooks/use-event.js';
var d = m(null);
function f() {
  var r = D(d);
  if (r === null) {
    var t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, f), t;
  }
  return r;
}
function M() {
  var _T = T([]),
    _T2 = _slicedToArray(_T, 2),
    r = _T2[0],
    t = _T2[1];
  return [r.length > 0 ? r.join(" ") : void 0, l(function () {
    return function (e) {
      var i = I(function (s) {
          return t(function (o) {
            return [].concat(_toConsumableArray(o), [s]);
          }), function () {
            return t(function (o) {
              var p = o.slice(),
                c = p.indexOf(s);
              return c !== -1 && p.splice(c, 1), p;
            });
          };
        }),
        n = l(function () {
          return {
            register: i,
            slot: e.slot,
            name: e.name,
            props: e.props
          };
        }, [i, e.slot, e.name, e.props]);
      return u.createElement(d.Provider, {
        value: n
      }, e.children);
    };
  }, [t])];
}
var S = "p";
function h(r, t) {
  var a = P(),
    _r$id = r.id,
    e = _r$id === void 0 ? "headlessui-description-".concat(a) : _r$id,
    i = _objectWithoutProperties(r, _excluded),
    n = f(),
    s = R(t);
  x(function () {
    return n.register(e);
  }, [e, n.register]);
  var o = _objectSpread(_objectSpread({
    ref: s
  }, n.props), {}, {
    id: e
  });
  return E({
    ourProps: o,
    theirProps: i,
    slot: n.slot || {},
    defaultTag: S,
    name: n.name || "Description"
  });
}
var y = g(h),
  b = Object.assign(y, {});
export { b as Description, M as useDescriptions };